import type { MarketingBlock } from '~/types/_next/listing';
import type { ProductModels } from '~/types/models/product.models';

const transformMarketingBlock = (marketingCards: any) => {
  if (!marketingCards) return [];

  return marketingCards.map((card: any) => {
    const {
      sys,
      title,
      disableDescription,
      tagColor,
      tagTitle,
      backgroundImage,
      description,
      externalLink,
      internalLink,
      isLinkCrawlableSeo,
      marketingBanner,
    } = card;

    return {
      fields: {
        id: sys.id ?? marketingBanner?.sys?.id,
        title: title ?? marketingBanner?.title,
        description: disableDescription ? '' : (description ?? marketingBanner?.description),
        tagColor: tagColor ?? marketingBanner?.tagColor,
        tagTitle: tagTitle ?? marketingBanner?.tagTitle,
        backgroundImage: backgroundImage ?? marketingBanner?.backgroundImage,
        externalLink: externalLink ?? marketingBanner?.externalLink,
        internalLink: internalLink ?? marketingBanner?.internalLink,
        isLinkCrawlableSeo,
      },
    };
  });
};

const transformMarketingBlockGraphql = (marketingCards: any) => {
  if (!marketingCards) return [];

  return marketingCards.map((card: any) => {
    const {
      sys,
      title,
      disableDescription,
      tagColor,
      tagTitle,
      backgroundImage,
      description,
      externalLink,
      internalLink,
      isLinkCrawlableSeo,
      marketingBanner,
    } = card;

    return {
      id: sys.id ?? marketingBanner?.sys?.id,
      title: title ?? marketingBanner?.title,
      description: disableDescription ? '' : (description ?? marketingBanner?.description),
      tagColor: tagColor ?? marketingBanner?.tagColor,
      tagTitle: tagTitle ?? marketingBanner?.tagTitle,
      backgroundImage: backgroundImage ?? marketingBanner?.backgroundImage,
      externalLink: externalLink ?? marketingBanner?.externalLink,
      internalLink: internalLink ?? marketingBanner?.internalLink,
      isLinkCrawlableSeo,
    };
  });
};

const mergeMarketingBlocksWithProducts = (
  marketingBlocks: Array<any>,
  activeProducts: Array<any>,
): Array<ProductModels.CustomProductVariant | MarketingBlock> => {
  const MARKETING_BLOCKS_POSITIONS = [2, 11];
  const productsCopy = [...activeProducts];

  const addMarketingBlockToListingAt = (marketingBlock: any[], index: number) => {
    productsCopy.splice(index, 0, {
      type: 'marketingBlock',
      value: marketingBlock,
    });
  };

  if (MARKETING_BLOCKS_POSITIONS.length < marketingBlocks.length && process.env.NODE_ENV === 'development') {
    console.warn('Marketing blocks positions are less than the number of marketing blocks');
    console.warn('The following marketing blocks will not be displayed:');
    console.warn(JSON.stringify(marketingBlocks.slice(MARKETING_BLOCKS_POSITIONS.length), null, 2));
  }

  marketingBlocks.forEach((b, i) => {
    if (!MARKETING_BLOCKS_POSITIONS[i]) return;

    addMarketingBlockToListingAt(b, MARKETING_BLOCKS_POSITIONS[i]);
  });

  return productsCopy;
};

export { transformMarketingBlock, transformMarketingBlockGraphql, mergeMarketingBlocksWithProducts };
